@if (visible()) {
  <div class="pagination">
    <div class="summary">
      Showing <strong>{{ start() }}</strong>–<strong>{{ end() }}</strong> of
      <strong>{{ total() }}</strong> {{ label() }}
    </div>

    <div class="controls">
      <button
        type="button"
        class="pg pg-arrow"
        [disabled]="page() <= 1"
        (click)="go(page() - 1)"
        aria-label="Previous page"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>

      @for (item of items(); track $index) {
        @if (item === 'ellipsis') {
          <span class="ellipsis">…</span>
        } @else {
          <button
            type="button"
            class="pg"
            [class.current]="item === page()"
            [attr.aria-current]="item === page() ? 'page' : null"
            (click)="go(item)"
          >
            {{ item }}
          </button>
        }
      }

      <button
        type="button"
        class="pg pg-arrow"
        [disabled]="page() >= totalPages()"
        (click)="go(page() + 1)"
        aria-label="Next page"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  </div>
}
